import { render, staticRenderFns } from "./PatientMedicalInsOnlySelect.vue?vue&type=template&id=f06c9928&"
import script from "./PatientMedicalInsOnlySelect.vue?vue&type=script&lang=ts&"
export * from "./PatientMedicalInsOnlySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports